import { ReactNode, useEffect } from "react";
import { GetWBComponentByTypename } from "../Data/WBData";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";
import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner from "../WebDesigner";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { useRef } from "react";
import fadeInElement from "../Utilities/ElementAnimator";
import { ImageIcon } from "../Icons/ComponentIcons";
import HamburgerIcon from "vagaro-website-rendering/src/components/Icons/Hamburger";

enum LayoutIconType{
    None,
    Image,
    Text,
    Buttons,
    Save

}

export default function WBComponentTemplateMenu({node,designer,onClose,}:{node:LayoutNode,designer:WebDesigner,onClose:Function}){


  
    const ref = useRef<HTMLDivElement>(null);
    let component = GetWBComponentByTypename(node.typename);

    useEffect(()=>{

        if(ref.current)
            fadeInElement(ref.current,200);
    },[])


    if(!component){

        onClose();
        return null;
    }

    const templates = componentTemplates.filter((template)=>template.componentTypename == component.typename);

    let str =  localStorage.getItem("vwbsavedtemplate");
    if(str){
        const newTemplate = {
            label:"Saved Template",
            icon:<GetLayoutIcon
                layout={[
                    {type:LayoutIconType.Save,
                        xStart:0,
                        xEnd:1,
                        yStart:0,
                        yEnd:1}
                     ]}
             />
           ,
            componentTypename:wBComponentTypeNames.section,
            layoutString:str,
        }

        templates.push(newTemplate);
    }
    

    const onSelectTemplate = (template:ComponentTemplateDefinition)=>{
       
        let newNode =  designer.convertLayoutStringToLayoutNode(template.layoutString);
        if(newNode==null||node.parent==null){
            console.warn("invalid template");
            return;

        }

        newNode.parent = node.parent;
        let index = node.parent?.children.indexOf(node)??0;
        node.parent.children[index] = newNode;
        //node.forceUpdate();
        designer.saveUndoState();
        
        setTimeout(()=>{ if(newNode){ designer.selectElementByLayoutObj(newNode);}},0);
      
        onClose();
    };






    const RenderTemplateButton = ({template}:{template:ComponentTemplateDefinition})=>{


        return <button onClick={()=>{onSelectTemplate(template)}} style={{position:"relative",paddingBottom:"20px"}}>
            {template.icon}
            <div className="center-all w-full font-small" style={{position:"absolute",bottom:"0",left:"0",color:"#333",letterSpacing:".05em"}}>{template.label}</div>
        </button>
    }

    return(
        <div className = "center-all" ref = {ref} style={{position:"fixed",top:"0px",left:"0px",width:"100vw",height:"100vh",backgroundColor:"rgba(0,0,0,0.2)",opacity:0,zIndex:200}} >
        <div className="component-template-menu-container">

            <div style={{display:"flex",justifyContent:"space-between",padding:"20px 20px 0px 20px"}}>
                <h2 className="panel-heading">Add {component.displayName}</h2>
                <div style={{width:"16px",height:"16px",cursor:"pointer"}} onClick={()=>{onClose() ;designer.deleteObjectById(node.id)}}><XIcon/></div>

            </div>
            <div className="component-template-menu-content">
                {templates.map((template,index)=><RenderTemplateButton key={index} template={template}/>)}
            </div>


        </div>
        </div>

    )


}

export type ComponentTemplateDefinition = {
    label:string,
    icon:ReactNode,
    componentTypename:string,
    layoutString:string,
}


type LayoutIcon = {
    type:LayoutIconType,
    xStart:number,
    xEnd:number,
    yStart:number,
    yEnd:number,
    
}


function GetLayoutIcon({layout}:{layout:LayoutIcon[]}){

    let totalWidth = 0;
    let totalHeight = 0;

    for(let i = 0;i<layout.length;i++){
        if(layout[i].xEnd>totalWidth)
            totalWidth = layout[i].xEnd;
        if(layout[i].yEnd>totalHeight)
            totalHeight = layout[i].yEnd;
    }

    let widthFrac = (100/totalWidth );
    let heightFrac = (100/totalHeight );
    return <>
    <div className="layout-icon-container">
        {
            layout.map((icon,index)=>{
                return  <div className="layout-icon" key = {index}
                
                style={{ 
                    left:`${icon.xStart*widthFrac}%`,
                    top:`${icon.yStart*heightFrac}%`,
                    width:`${(icon.xEnd-icon.xStart)*widthFrac}%`,
                    height:`${(icon.yEnd-icon.yStart)*heightFrac}%`,

                }}
                
                >
                    
                    <RenderLayoutSymbol layoutType={icon.type}/>

                </div>

            })
        }
        </div>
    </>


}

function RenderLayoutSymbol({layoutType}:{layoutType:LayoutIconType}){

    switch(layoutType){
        case LayoutIconType.Image:
            return <ImageIcon/>
        case LayoutIconType.Text:
            return <HamburgerIcon/>
        case LayoutIconType.Buttons:
            return <ButtonGroupIcon/>
        case LayoutIconType.Save:
           return <svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 512 512" fill="currentColor"><path d="M80 96v16c0 17.7 14.3 32 32 32h60.8c16.6-28.7 47.6-48 83.2-48h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80zm64-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 464c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H384v48c0 17.7 14.3 32 32 32h48V448c0 8.8-7.2 16-16 16H256zm192 48c35.3 0 64-28.7 64-64V227.9c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448z"/></svg>
        default:
            return null;
    }

}


const ButtonIcon = ()=>{

    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 640 512"><path d="M576 112c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H576zM64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"/></svg>
}

const ButtonGroupIcon = ()=>{

return <div className="flex-row center-all gap-small">
    <ButtonIcon/>
    <ButtonIcon/>
    <ButtonIcon/>
    </div>


}

export const componentTemplates : ComponentTemplateDefinition[] = [
    {
        label:"Blank",
        icon:<GetLayoutIcon
            layout={[
                {type:LayoutIconType.None,
                    xStart:0,
                    xEnd:1,
                    yStart:0,
                    yEnd:1}
                 ]}
         />
       ,
        componentTypename:wBComponentTypeNames.section,
        layoutString:`{"id":"n97c93185e4cabe68e564940c3c582c2","typename":"Section","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"O642a57c03f521b0bfca2c1aaabda100","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","justifyContent":"center","alignItems":"center","alignContent":"center"},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[],"renderChildren":true}],"renderChildren":true}`,
    },

    {
        label:"Call To Action",
        icon:<GetLayoutIcon
            layout={[
                {type:LayoutIconType.Text,
                    xStart:0,
                    xEnd:1,
                    yStart:0,
                    yEnd:1}
                 ]}
         />
       ,
        componentTypename:wBComponentTypeNames.section,
        layoutString:`{"id":"u6133fc35a2be8519c8d606d48bd113e","typename":"Section","screenSizeStyleAttributes":[{"backgroundImage":"url(https://images.unsplash.com/photo-1621155346337-1d19476ba7d6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjIzNDR8MHwxfHNlYXJjaHwxM3x8aW1hZ2V8ZW58MHx8fHwxNjkyNjQ3MzEyfDA&ixlib=rb-4.0.3&q=80&w=1080)","color":"#ffffff"},{},{}],"componentAttributes":{"backgroundOverlayColor":"#00000024"},"content":"Your Text Here","children":[{"id":"g506b910b0017cd19cd9fc94a387649d","typename":"Column","screenSizeStyleAttributes":[{"gap":"10px","justifyContent":"center","alignContent":"flex-start","alignItems":"flex-start","padding":"120px"},{},{"padding":"42px"}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"Rf887209f25f49928ffce84470a09e5d","typename":"Heading","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"Your Call To Action","children":[]},{"id":"Me10d797a3a6b045a1883cbddefe0dba","typename":"Text","screenSizeStyleAttributes":[{"width":"607px"},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae elementum curabitur vitae nunc sed velit dignissim. In est ante in nibh mauris cursus mattis molestie. Ut sem viverra aliquet eget sit amet tellus. Adipiscing commodo elit at imperdiet.&nbsp;","children":[]},{"id":"eab2a6c42ea470d6976dc1fecf7e2adb","typename":"button","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"Click Here!","children":[]}],"renderChildren":true}],"renderChildren":true}`,
    },

    {
        label:"Side by Side",
        icon:<GetLayoutIcon
        layout={[
            {type:LayoutIconType.Text,
                xStart:0,
                xEnd:1,
                yStart:0,
                yEnd:1
            },
            {type:LayoutIconType.Image,
                xStart:1,
                xEnd:2,
                yStart:0,
                yEnd:1
            }
    
             ]}
     />,
        componentTypename:wBComponentTypeNames.section,
        layoutString:`{"id":"p8ed07c8d8f49e4a9f32c8241a32aa1d","typename":"Section","screenSizeStyleAttributes":[{},{},{"height":"100%"}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"Q3267b16f15e27b78ae14d8407269b60","typename":"Column","screenSizeStyleAttributes":[{"justifyContent":"flex-start","alignItems":"flex-start","alignContent":"flex-start","padding":"98px","gap":"18px"},{"padding":"58px"},{"justifyContent":"center"}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"yadc616c454a20e1ae2a553f8dadeb12","typename":"Heading","screenSizeStyleAttributes":[{"letterSpacing":".1em"},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h4"},"content":"<b>Sub Heading</b>","children":[]},{"id":"e95566c2529421c38b12dd2c8605a12f","typename":"Heading","screenSizeStyleAttributes":[{"letterSpacing":".1em"},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h2"},"content":"Main Heading","children":[]},{"id":"V69c2e727d296d7cb8e63d7bd9134436","typename":"Text","screenSizeStyleAttributes":[{},{"height":"473px"},{}],"componentAttributes":{"anchorType":"top-left"},"content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae elementum curabitur vitae nunc sed velit dignissim. In est ante in nibh mauris cursus mattis molestie. Ut sem viverra aliquet eget sit amet tellus. Adipiscing commodo elit at imperdiet. Gravida in fermentum et sollicitudin ac. Dictumst quisque sagittis purus sit. Enim lobortis scelerisque fermentum dui faucibus in ornare quam. Consectetur purus ut faucibus pulvinar.","children":[]}]},{"id":"N99c71b513c13384960c989fadc01942","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","alignItems":"center","alignContent":"center","justifyContent":"center"},{},{"height":"458px"}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"r4449ab74c727133a8c3798a1ccb911e","typename":"Image","screenSizeStyleAttributes":[{"height":"464px","width":"100%"},{},{"height":"343px"}],"componentAttributes":{"imageSrc":"https://images.unsplash.com/photo-1621155346337-1d19476ba7d6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjIzNDR8MHwxfHNlYXJjaHwxM3x8aW1hZ2V8ZW58MHx8fHwxNjkyNjQ3MzEyfDA&ixlib=rb-4.0.3&q=80&w=1080","imageHeight":"720px","anchorType":"top-left"},"content":"Your Text Here","children":[]}]}]}`    },
    {
        label:"3 Cards",
        icon:<GetLayoutIcon
        layout={[
            {type:LayoutIconType.Image,
                xStart:1,
                xEnd:2,
                yStart:0,
                yEnd:1
            },
            {type:LayoutIconType.Image,
                xStart:0,
                xEnd:1,
                yStart:0,
                yEnd:1
            },
            {type:LayoutIconType.Image,
                xStart:2,
                xEnd:3,
                yStart:0,
                yEnd:1
            }
             ]}
     />,
        componentTypename:wBComponentTypeNames.section,
        layoutString:`{"id":"qf8ae763817a9c43b104cdad91a9151a","typename":"Section","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"c87431962f8805b3821ffcd45060bf16","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","justifyContent":"center","alignItems":"center","alignContent":"center","padding":"24px"},{"padding":"6px"},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"Nd8ffeb57562d10fb80360ef3f3e32be","typename":"container","screenSizeStyleAttributes":[{"justifyContent":"flex-end","alignContent":"center","alignItems":"center","flexDirection":"column","width":"319px","height":"368px","backgroundImage":"url(https://images.unsplash.com/photo-1574169207511-e21a21c8075a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjIzNDR8MHwxfHNlYXJjaHw5fHxpbWFnZXxlbnwwfHx8fDE2OTI2NDczMTJ8MA&ixlib=rb-4.0.3&q=80&w=1080)","boxShadow":"0px 3px 40px -10px rgba(0,0,0,0.6)","borderRadius":"12px","padding":"24px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"flex-end","anchorType":"top-left","backgroundOverlayColor":"#2d2d2d30"},"content":"","children":[{"id":"q19602bb251a19a5aca03f634a12a44d","typename":"Heading","screenSizeStyleAttributes":[{"color":"#ffffff"},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h2"},"content":"Card Title","children":[]},{"id":"E554c0d5efc883488f9b44898dadbec5","typename":"Text","screenSizeStyleAttributes":[{"color":"#ffffff"},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"This is some info about your card!","children":[]}]},{"id":"T79d2bfab4444604b36e4d565dba1ac7","typename":"Text","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"subtext here","children":[]}]},{"id":"fc93c98483ab8beba39fdc9a41d85079","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","justifyContent":"center","alignItems":"center","alignContent":"center","padding":"24px"},{"padding":"6px"},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"Td455426a98583219668e8920fcb16a1","typename":"container","screenSizeStyleAttributes":[{"justifyContent":"flex-end","alignContent":"center","alignItems":"center","flexDirection":"column","width":"319px","height":"368px","backgroundImage":"url(https://images.unsplash.com/photo-1578589318433-39b5de440c3f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjIzNDR8MHwxfHNlYXJjaHwyM3x8aW1hZ2V8ZW58MHx8fHwxNjkyNjQ3MzEyfDA&ixlib=rb-4.0.3&q=80&w=1080)","boxShadow":"0px 3px 40px -10px rgba(0,0,0,0.6)","borderRadius":"12px","padding":"24px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"flex-end","anchorType":"top-left","backgroundOverlayColor":"#2d2d2d30"},"content":"","children":[{"id":"I95b1317fe04efcca8ea39ca0ceabbc0","typename":"Heading","screenSizeStyleAttributes":[{"color":"#ffffff"},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h2"},"content":"Card Title","children":[]},{"id":"u5de0f21b966ae8b8c41e69579732c86","typename":"Text","screenSizeStyleAttributes":[{"color":"#ffffff"},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"This is some info about your card!","children":[]}]},{"id":"Ba69e63877061ab980d0d6d4d9cf7f23","typename":"Text","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"subtext here","children":[]}]},{"id":"ha888c8b48184b9c8696160450cbe24f","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","justifyContent":"center","alignItems":"center","alignContent":"center","padding":"24px"},{"padding":"6px"},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"G9efab4175b8b0b9bc0ab15d6f6e9b59","typename":"container","screenSizeStyleAttributes":[{"justifyContent":"flex-end","alignContent":"center","alignItems":"center","flexDirection":"column","width":"319px","height":"368px","backgroundImage":"url(https://images.unsplash.com/photo-1684430127468-2befa3b1c211?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjIzNDR8MHwxfHNlYXJjaHw2fHxjYXJkJTIwaW1hZ2V8ZW58MHx8fHwxNjkyNjQ4MDM3fDA&ixlib=rb-4.0.3&q=80&w=1080)","boxShadow":"0px 3px 40px -10px rgba(0,0,0,0.6)","borderRadius":"12px","padding":"24px"},{},{}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"flex-end","anchorType":"top-left","backgroundOverlayColor":"#2d2d2d30"},"content":"","children":[{"id":"x540d94340dc25b481471c1c1fd0b38e","typename":"Heading","screenSizeStyleAttributes":[{"color":"#ffffff"},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h2"},"content":"Card Title","children":[]},{"id":"O6c3173006adb97982eb2bf6b918b04f","typename":"Text","screenSizeStyleAttributes":[{"color":"#ffffff"},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"This is some info about your card!","children":[]}]},{"id":"B703712bd14aea018ff309a1134d220e","typename":"Text","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"subtext here","children":[]}]}]}`
    },
    {
        label:"Quote",
        icon:<GetLayoutIcon
        layout={[
            {type:LayoutIconType.Image,
                xStart:0,
                xEnd:1,
                yStart:0,
                yEnd:1
            },
            {type:LayoutIconType.Text,
                xStart:1,
                xEnd:3,
                yStart:0,
                yEnd:1
            },
     
             ]}
     />,
        componentTypename:wBComponentTypeNames.section,
        layoutString:`{"id":"v42f9cd91fa74de08883ebeb0f9c9377","typename":"Section","screenSizeStyleAttributes":[{"padding":"48px"},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"Kc25cbeed1ae7123a8a73bab9cd12a04","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","justifyContent":"center","alignItems":"flex-end","alignContent":"flex-end"},{},{"alignItems":"center","alignContent":"center"}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"a46de87b0b0d9f2586895a7b8e721f7a","typename":"Image","screenSizeStyleAttributes":[{"height":"200px","borderRadius":"500px","width":"200px"},{},{}],"componentAttributes":{"anchorType":"top-left","imageSrc":"https://images.unsplash.com/photo-1611199340099-91a595a86812?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NjIzNDR8MHwxfHNlYXJjaHwxM3x8QXV0aG9yfGVufDB8fHx8MTY5Mjc0MDk2M3ww&ixlib=rb-4.0.3&q=80&w=1080","imageHeight":"1620px"},"content":"","children":[]}]},{"id":"Ab35dd8f12da57f6a68e619c6d5434e3","typename":"Column","screenSizeStyleAttributes":[{"gap":"4px","justifyContent":"center","alignItems":"flex-start","alignContent":"flex-start","flexGrow":"3"},{"flexGrow":"2"},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"b06b11b4ea8a54fa898ff2282c1fbd39","typename":"Text","screenSizeStyleAttributes":[{"fontSize":"1.9em","width":"100%","fontWeight":"600","textAlign":"right"},{"width":"376px","height":"100%"},{"textAlign":"left"}],"componentAttributes":{"anchorType":"top-left"},"content":"&quot;Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat&quot;","children":[]},{"id":"l603e0c087a0a2349260dcd33806afa0","typename":"Text","screenSizeStyleAttributes":[{"width":"100%","textAlign":"right","fontSize":"1.4em","padding":"0px 70px 0px 0px"},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"-Author Name","children":[]}]}]}`
            },
            {
                label:"Button Group",
                icon:<GetLayoutIcon
                layout={[
                    {type:LayoutIconType.Buttons,
                        xStart:0,
                        xEnd:1,
                        yStart:0,
                        yEnd:1
                    }
             
                     ]}
             />,
                componentTypename:wBComponentTypeNames.section,
                layoutString:`{"id":"E8db3d661519b8d9aaed7ec79fbcdcd8","typename":"Section","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{},"content":"Your Text Here","children":[{"id":"U6290b23b491b63d8e51e95dcb6f5a77","typename":"Column","screenSizeStyleAttributes":[{"gap":"10px","justifyContent":"center","alignContent":"center","alignItems":"center","padding":"100px"},{},{"padding":"42px"}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center"},"content":"Your Text Here","children":[{"id":"jff9c090837c453ca0f069924aafa0ba","typename":"Heading","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h2"},"content":"Click Here!","children":[]},{"id":"Z1d85b1b28a5ab8cbceec3d08f0b2c89","typename":"Heading","screenSizeStyleAttributes":[{},{},{}],"componentAttributes":{"anchorType":"top-left","headingType":"h4"},"content":"make your selection","children":[]},{"id":"k9616b2bdbdfcedb9c19b4f999189ccd","typename":"container","screenSizeStyleAttributes":[{"justifyContent":"center","alignContent":"center","alignItems":"center","flexDirection":"row","width":"100%","gap":"10px","height":"78px"},{},{"flexWrap":"wrap","width":"219px","height":"196px","gap":"11px"}],"componentAttributes":{"horizontalAlign":"center","verticalAlign":"center","anchorType":"top-left"},"content":"","children":[{"id":"Fac8e0a0499feda48f24f6f57a50dd68","typename":"button","screenSizeStyleAttributes":[{"width":"140px"},{},{}],"componentAttributes":{"anchorType":"top-left"},"content":"Primary","children":[]},{"id":"Ef0b3d3fbe3c8975bc8ce942711ae29b","typename":"button","screenSizeStyleAttributes":[{"width":"140px"},{},{}],"componentAttributes":{"anchorType":"top-left","buttonType":"secondary"},"content":"Secondary","children":[]},{"id":"q4818eb6dd5424a698b9f3f026ffc76a","typename":"button","screenSizeStyleAttributes":[{"width":"140px"},{},{}],"componentAttributes":{"anchorType":"top-left","buttonType":"tertiary"},"content":"Tertiary","children":[]}]}],"renderChildren":true}],"renderChildren":true}`
                    }
]